import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead, TablePagination,
  TableRow
} from "@material-ui/core";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CircularProgress from "@material-ui/core/CircularProgress";
import { APP_TABLE_SETTINGS } from "../../../_constants";
import PropTypes from "prop-types";
import TablePaginationActions from "../../_shared/TablePaginationAction";
import { IEDistributionDto } from "../../../_models";

const IEDistributionList = (props) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(APP_TABLE_SETTINGS.DEFAULT_TABLE_PAGE_SIZE);

  React.useEffect(() => {
    if (!!props.data && props.data.length > 0) {
      setPage(0);
    }
  }, [props.data])

  // handle pagination page change event
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  // handle pagination rows per page dropdown change event
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <TableContainer>
      <Table size="small" stickyHeader className={'appTable'}>
        <TableHead>
          <TableRow>
            <TableCell>IE Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>VSM Code</TableCell>
            <TableCell>Shift</TableCell>
            <TableCell>Module</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.isLoading ? <TableRow><TableCell colSpan={7}> <CircularProgress size={20} /> Loading ...</TableCell></TableRow> : null}
          {props.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row: IEDistributionDto) => {
            return (
              <TableRow key={row.id}>
                <TableCell>{row?.ieName?.trim()}</TableCell>
                <TableCell>{row?.emailAddress?.trim()}</TableCell>
                <TableCell>{row?.vsmCode?.trim()}</TableCell>
                <TableCell>{row?.shift?.trim()}</TableCell>
                <TableCell>{row?.module?.trim()}</TableCell>
                <TableCell>
                  <a className={'textPrimary mrM'} onClick={() => props.initIEDistributionEdit(true, row.id)}>
                    <EditIcon className="vAlignMiddle" />Edit
                  </a>
                  <a className={'textPrimary'} onClick={() => props.initIEDistributionDelete(true, row.id, row.ieName)}>
                    <DeleteIcon className="vAlignMiddle" />Delete
                  </a>
                </TableCell>
              </TableRow>
            )
          })}
          {(!props.isLoading && props.data.length == 0) ? <TableRow><TableCell colSpan={7}> No data found.</TableCell></TableRow> : null}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={APP_TABLE_SETTINGS.DEFAULT_ROWS_PER_PAGE}
        component="div"
        count={props.data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        ActionsComponent={TablePaginationActions}
      />
    </TableContainer>
  );
};

IEDistributionList.propTypes = {
  initIEDistributionEdit: PropTypes.func,
  initIEDistributionDelete: PropTypes.func,
  data: PropTypes.array.isRequired,
  isWebview: PropTypes.bool,
  isLoading: PropTypes.bool
}

export default IEDistributionList;
